import { render, staticRenderFns } from "./h3c-server-table.vue?vue&type=template&id=2da1489f&scoped=true&"
import script from "./h3c-server-table.vue?vue&type=script&lang=js&"
export * from "./h3c-server-table.vue?vue&type=script&lang=js&"
import style0 from "./h3c-server-table.vue?vue&type=style&index=0&id=2da1489f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da1489f",
  null
  
)

export default component.exports